import { IBookableDatesInfo } from "@/domain/entities/book";
import { injectable } from "inversify";

export interface IsDailyBookCheaperUseCase {
  execute(
    dailyFare: number,
    monthlyFare: number,
    monthlyDatesInfo?: IBookableDatesInfo
  ): boolean;
}

@injectable()
export class IsDailyBookCheaper implements IsDailyBookCheaperUseCase {
  constructor() {}

  execute(
    dailyFare: number,
    monthlyFare: number,
    monthlyDatesInfo?: IBookableDatesInfo
  ) {
    const bookableDates =
      monthlyDatesInfo?.bookableDates.filter(
        (dateInfo) => !dateInfo.isBookedByMe
      ) ?? [];
    return monthlyFare > dailyFare * bookableDates.length;
  }
}
